import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Hidden,
  Stack,
  Typography,
} from "@mui/material";
import finance from "financejs";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  numberFormat,
  participationsFormat,
} from "../../../helpers/numberFormat";
import { useTranslation } from "react-i18next";
import { DetailRealizedStartup } from "./DetailRealizedStartup";
import { transformDivestments } from "../../../helpers/finance";

export const DivestmentClubTableSmall = ({ rows }) => {
  const { t } = useTranslation("global");
  const startupList = rows.map((alias) => alias.startupAlias);
  const startupListNoRepeat = startupList.filter((item, index) => {
    return startupList.indexOf(item) === index;
  });
  const objByStartup = startupListNoRepeat.map((startup) => {
    return {
      id: startup,
      startup,
      data: rows.filter((investment) => investment.startupAlias === startup),
    };
  });

  const amount = (data) =>
    data.data
      .map(
        (invest) =>
          invest.divestmentParticipation * invest.participationValuation
      )
      .reduce((a, b) => a + b, 0);

  const capitalGain = (data) =>
    data.data
      .map(
        (invest) =>
          invest.divestmentParticipation * invest.salesPrice -
          invest.divestmentParticipation * invest.participationValuation
      )
      .reduce((a, b) => a + b, 0);

  return objByStartup.map((invest) => {
    const moic = () => {
      const amount = invest.data
        .map(
          (invest) =>
            invest.divestmentParticipation * invest.participationValuation
        )
        .reduce((a, b) => a + b, 0);
      const res = invest.data.map((invest) => {
        const newCapital = invest.divestmentParticipation * invest.salesPrice;
        const resp =
          newCapital -
          invest.divestmentParticipation * invest.participationValuation;
        return resp;
      });
      const capitalGain = res.reduce((a, b) => a + b, 0);

      return participationsFormat((capitalGain + amount) / amount) + "x";
    };

    const tir = () => {
      const investments = invest.data.map((inv) => {
        const newCapital = inv.divestmentParticipation * inv.salesPrice;
        const capitalGain =
          newCapital - inv.divestmentParticipation * inv.participationValuation;

        return {
          cashflow: inv?.divestmentParticipation * inv?.participationValuation,
          investmentDate: inv.investmentDate,
          capitalGain:
            capitalGain === -0 ? 0 : parseInt(capitalGain.toFixed(2)),
          divestmentDate: inv.divestmentDate,
        };
      });

      const investmentsFinal = transformDivestments(investments);
      const financeInstance = new finance();
      try {
        const tir = financeInstance.XIRR(
          investmentsFinal.map((inv) => parseFloat(inv.cashflow.toFixed(2))),
          investmentsFinal.map((inv) => new Date(inv.investmentDate)),
          -0.9
        )
        
      return (
        isNaN(tir) || tir === Infinity ? '-100,00%' : tir.toFixed(2) + '%'
      );
      } catch (error) {
        console.error("Error al calcular la TIR:", error);
        return "-100,00%";
      }
    };

    return (
      <Hidden mdUp key={invest.id}>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Stack
              width="100%"
              direction="row"
              flexWrap="wrap"
              justifyContent="space-evenly"
              gap={1}
            >
              <Stack
                direction="row"
                flexWrap="wrap"
                md={{ justifyContent: "space-between" }}
              >
                <Typography
                  variant="caption"
                  color="primary"
                  marginRight="10px"
                >
                  {t("positions.startup")}:{" "}
                </Typography>
                <Typography variant="caption" color="secondary">
                  {invest.startup}
                </Typography>
              </Stack>
              <Stack
                direction="row"
                flexWrap="wrap"
                md={{ justifyContent: "space-between" }}
              >
                <Typography
                  variant="caption"
                  color="primary"
                  marginRight="10px"
                >
                  {t("positions.amount")}:
                </Typography>
                <Typography
                  variant="caption"
                  color={
                    invest.myStatus === "Reserva realizada"
                      ? "success.main"
                      : "secondary"
                  }
                >
                  {numberFormat(amount(invest).toFixed(2))}
                </Typography>
              </Stack>
              <Stack
                direction="row"
                flexWrap="wrap"
                md={{ justifyContent: "space-between" }}
              >
                <Typography
                  variant="caption"
                  color="primary"
                  marginRight="10px"
                >
                  {t("positions.tir")}:
                </Typography>
                <Typography variant="caption" color={"secondary"}>
                  {tir()}
                </Typography>
              </Stack>
              <Stack
                direction="row"
                flexWrap="wrap"
                md={{ justifyContent: "space-between" }}
              >
                <Typography
                  variant="caption"
                  color="primary"
                  marginRight="10px"
                >
                  {t("positions.moic")}:
                </Typography>
                <Typography variant="caption" color={"secondary"}>
                  {moic()}
                </Typography>
              </Stack>
              <Stack
                direction="row"
                flexWrap="wrap"
                md={{ justifyContent: "space-between" }}
              >
                <Typography
                  variant="caption"
                  color="primary"
                  marginRight="10px"
                >
                  {t("positions.capitalGain")}:
                </Typography>
                <Typography variant="caption" color="secondary">
                  {numberFormat(capitalGain(invest).toFixed(2))}
                </Typography>
              </Stack>
            </Stack>
          </AccordionSummary>
          <AccordionDetails>
            {invest.data.map((detail) => {
              return <DetailRealizedStartup row={detail} key={detail.id} />;
            })}
          </AccordionDetails>
        </Accordion>
      </Hidden>
    );
  });
};
